import getService from 'src/core/services/base'
import apiKey from 'src/core/services/base/apiKey'

// type
import type { OrderLensResponse } from './model'

const url = '/order/lens' as const

/**
 * W06-01 查詢會員購物車內容(鏡片)
 */
export function getOrderLens(params: { language: string }, openUnAutoToast?: () => void) {
  return getService<OrderLensResponse>(
    {
      config: {
        url,
        method: 'get',
        params,
      },
      name: apiKey.getOrderLens,
    },
    openUnAutoToast,
  ).then((res) => res.data.result_data)
}
